import { EmptyValue } from "@/components/ui/empty-value";
import { ReactNode } from "react";

interface DetailViewProps {
  label: ReactNode;
  value?: ReactNode;
}

export const DetailValue = ({ label, value }: DetailViewProps) => {
  return (
    <div className="rounded-lg border p-3">
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div className="mt-1 text-sm">{value ?? <EmptyValue />}</div>
    </div>
  );
};
